// internal deps
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

// constants
import {
    CLICK_ACTIONS,
    SCREEN_NAME,
} from "@payment-client/analytics/constants";

export const onPODPaymentClickEvent = (amount: number, clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_POD,
        context: JSON.stringify({ amount }),
    });
};

export const onPODPayButtonClick = (amount: number, clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_POD_PAY,
        context: JSON.stringify({ amount }),
    });
};